import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_BASIC_CUSTOMER_REQUEST = 'GET_BASIC_CUSTOMER_REQUEST';
export const GET_BASIC_CUSTOMER_SUCCESS = 'GET_BASIC_CUSTOMER_SUCCESS';
export const GET_BASIC_CUSTOMER_FAILURE = 'GET_BASIC_CUSTOMER_FAILURE';

function requestGetBasicCustomer() {
  return {
    type: GET_BASIC_CUSTOMER_REQUEST,
    isGettingBasicCustomer: true
  };
}

function receiveGetBasicCustomer(basicCustomer) {
  return {
    type: GET_BASIC_CUSTOMER_SUCCESS,
    isGettingBasicCustomer: false,
    basicCustomer
  };
}

function rejectGetBasicCustomer() {
  return {
    type: GET_BASIC_CUSTOMER_FAILURE,
    isGettingBasicCustomer: false
  };
}

export function getBasicCustomer(customerId) {
  return (dispatch) => {
    dispatch(requestGetBasicCustomer());

    const promise = () => ApiService
      .getBasicCustomer(customerId)
      .then((response) => {
        dispatch(receiveGetBasicCustomer(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetBasicCustomer));
        }
      });
    return promise();
  };
}
